import axios from 'axios';

const getEmails = () => axios.get('/messagesettings');

const getVariables = (emailType) => axios.get(`/messagesettings/${emailType}/variables`);

// получить черновик шаблона для отображения в превью
const getTemplate = (emailType, companyId, data) =>
  axios.post(`/messagesettings/${emailType}/template`, data, {
    params: {company_id: companyId},
  });

const getSettings = (emailType, companyId) =>
  axios.get(`/messagesettings/${emailType}/settings`, {
    params: {company_id: companyId},
  });

const changeSettings = (emailType, companyId, data) =>
  axios.post(`/messagesettings/${emailType}/settings`, data, {
    params: {company_id: companyId},
  });

const resetEmail = (emailType, companyId) =>
  axios.put(`/messagesettings/${emailType}/reset?company_id=${companyId}`);

export default {
  getEmails,
  getVariables,
  getTemplate,
  getSettings,
  changeSettings,
  resetEmail,
};
